var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"email-test"},[_c('EmailVisualEditor',{model:{value:(_vm.doc),callback:function ($$v) {_vm.doc=$$v},expression:"doc"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }